import { SystemConfig } from '../types';

export interface DriverCompensationConfig {
  dailyFee: number;
  dropFee: number;
}

const toNumber = (value: unknown): number | undefined => {
  if (typeof value !== 'number' || Number.isNaN(value)) return undefined;
  return value;
};

export const getDriverCompensationConfig = (config: SystemConfig): DriverCompensationConfig => ({
  dailyFee: toNumber(config.fleetConfig?.dailyFixedCost) ?? toNumber(config.dailyFixedCost) ?? 0,
  dropFee: toNumber(config.fleetConfig?.driverFixedFeePerOrder) ?? toNumber(config.driverFixedFeePerOrder) ?? 0,
});

export const calculateDriverDailyEarnings = (
  config: SystemConfig,
  totalDeliveries: number
): { totalDropEarnings: number; totalDailyEarnings: number; totalEarnings: number; dailyFee: number; dropFee: number } => {
  const { dailyFee, dropFee } = getDriverCompensationConfig(config);
  const safeDeliveries = Math.max(0, totalDeliveries || 0);
  const totalDropEarnings = safeDeliveries * dropFee;
  const totalDailyEarnings = safeDeliveries > 0 ? dailyFee : 0;

  return {
    dailyFee,
    dropFee,
    totalDropEarnings,
    totalDailyEarnings,
    totalEarnings: totalDropEarnings + totalDailyEarnings,
  };
};
